// extracted by mini-css-extract-plugin
export default {"card":"bvevB","card--bordered":"s6Yam","card--with-hover":"cs1a6"};